import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconQuestionMarkCircle16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconQuestionMarkCircle16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0m1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0M8.143 5c-.807 0-1.492.655-1.658 1.308a.5.5 0 1 1-.97-.247C5.779 5.03 6.816 4 8.144 4c.601 0 1.224.138 1.7.57.484.439.728 1.103.728 1.965 0 .917-.679 1.48-1.145 1.867l-.053.044c-.552.46-.838.737-.838 1.142a.5.5 0 0 1-1 0c0-.916.679-1.48 1.145-1.866l.053-.044c.552-.46.838-.738.838-1.143 0-.678-.187-1.032-.4-1.225-.223-.2-.564-.31-1.029-.31m.607 6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconQuestionMarkCircle16);
